import styled from 'styled-components';
import fonts from "../styles/fonts";

export const OverTimeButton = styled.button`
    background: #909090;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    padding-left: 8px;
    padding-right: 8px;

    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    // text-transform: uppercase;
    width: 98px;
    height: 23px;

    color: #FFFFFF;
    cursor: pointer;
    border: 0;
    outline: 0;
`

export const OverTimeDropdown = styled.select`
    background: #909090;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    padding-left: 8px;
    padding-right: 8px;
    border: none;
    appearance: none;
    outline: none;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    // text-transform: uppercase;
    width: 98px;
    height: 23px;

    color: #FFFFFF;
    cursor: pointer;
    border: 0;
    outline: 0;

`
